import { useContext } from "react";
import Header from "./Header/Header";
import Content from "./Content/Content";
import { Box, Stack } from "@mui/material";
import FooterLinks from "src/components/Footer/FooterLinks";
import { ThemeValues } from "src/components/ThemeUsage/theme";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";

const IntroductionLB = () => {
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;

  return (
    <Stack
      sx={(theme) => ({
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      })}
    >
      <Stack
        alignItems="center"
        sx={(theme) => ({
          width: "100%",
          minHeight: "100vh",
          px: 4,
        })}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{
            width: "fit-content",
            maxWidth: "1279px",
          }}
        >
          <Header />
          <Box
            sx={{
              height: "36px",
            }}
          />
          <Content />
        </Stack>
        <Box
          sx={{
            height: "36px",
          }}
        />
      </Stack>

      <FooterLinks isIntroductionPage={true} />
    </Stack>
  );
};

export default IntroductionLB;
